import { useEffect, useRef } from "react";

// Mensagem do sistema SEMPRE em janela modal (padrão do Ricardo, 15/10/2026):
// erro / atenção / concluído. OK com foco; Enter ou Esc fecham; o foco volta para onde estava.
interface Props {
  texto: string | null | undefined;
  tipo?: "erro" | "aviso" | "ok";
  onClose: () => void;
}

const TITULO = { erro: "Erro", aviso: "Atenção", ok: "Concluído" } as const;
const ICONE = { erro: "⛔", aviso: "⚠️", ok: "✅" } as const;

export function MsgModal({ texto, tipo = "erro", onClose }: Props) {
  const okRef = useRef<HTMLButtonElement>(null);
  const antes = useRef<Element | null>(null);

  useEffect(() => {
    if (!texto) return;
    antes.current = document.activeElement;
    setTimeout(() => okRef.current?.focus(), 0);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" || e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        fechar();
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texto]);

  function fechar() {
    onClose();
    const el = antes.current as HTMLElement | null;
    setTimeout(() => el?.focus?.(), 0);
  }

  if (!texto) return null;
  return (
    <div className="msg-modal-bg" role="alertdialog" aria-modal="true">
      <div className={`msg-modal msg-${tipo}`}>
        <div className="msg-modal-titulo">
          <span className="msg-modal-ico">{ICONE[tipo]}</span>
          {TITULO[tipo]}
        </div>
        <div className="msg-modal-texto">{texto}</div>
        <div className="msg-modal-acoes">
          <button ref={okRef} className="btn-acao" onClick={fechar}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
